import type {
  PendingPermissionGroupInvite,
  PendingPermissionInvite,
} from '@affine/core/modules/permissions/views/permission-create-modal-core';

export interface DocCreateConfig {
  name: string;
  pendingInvites: PendingPermissionInvite[];
  pendingGroupInvites: PendingPermissionGroupInvite[];
}

export const createDefaultDocCreateConfig = (
  name: string
): DocCreateConfig => ({
  name,
  pendingGroupInvites: [],
  pendingInvites: [],
});
